<section class="myTickets">
  <ng-container>
    <div class="myTicket-wrapper" *ngIf="invoices.data.length; else noData">
      <ngb-accordion
        #a="ngbAccordion"
        class="invoices-wrapper"
        [closeOthers]="true"
        (panelChange)="getTickets($event)"
      >
        <ng-container *ngFor="let invoice of invoices.data">
          <ngb-panel [id]="invoice.id" *ngIf="invoice">
            <ng-template ngbPanelHeader let-opened="opened">
              <button
                class="custom-header"
                ngbPanelToggle
                [class.collapsed]="!opened"
              >
                <figure class="event-image ratio-wrapper">
                  <img
                    class="ratio-wrapper__el"
                    [src]="
                      invoice.event.image?.image.url ||
                      'assets/images/placeholder-img.jpg'
                    "
                    alt=""
                  />
                </figure>
                <div class="details">
                  <h3>
                    {{ helpers.getElementTranslatedName(invoice.event) }}
                  </h3>
                  <p>
                    {{ invoice.number }}
                    {{ "Order Number" | translate }}
                  </p>
                </div>

                <div class="price">
                  <span
                    [innerHTML]="
                      invoice.total
                        | customCurrency : 'SAR' : 'symbol' : '#3dbeb4' : 30
                    "
                  ></span>
                  <i class="fas fa-chevron-down"></i>
                </div>
              </button>
            </ng-template>
            <ng-template ngbPanelContent>
              <ng-container *ngIf="selectedInvoiceTickets; else loading">
                <div class="d-flex align-items-center justify-content-between">
                  <h4>{{ "Tickets" | translate }}</h4>
                  <button
                    type="button"
                    (click)="downloadInvoice(invoice.id)"
                    class="btn myTicket-downloadBtn"
                  >
                    <i class="fas fa-cloud-download-alt"></i>
                    {{ "DownloadAllTickets" | translate }}
                  </button>
                </div>
                <div
                  class="myTicket"
                  *ngFor="let ticket of selectedInvoiceTickets"
                >
                  <div class="myTicket-part1">
                    <div class="myTicket-qr">
                      <div class="qrcodFrame">
                        <div
                          class="container_"
                          *ngIf="
                            ticket.approvalStatus ===
                              ApprovalStatusEnum.WaitingApproval ||
                            ticket.approvalStatus ===
                              ApprovalStatusEnum.DeclinedApproval
                          "
                        >
                          <div class="tag">
                            <p
                              style="font-size: 9px"
                              *ngIf="
                                ticket.approvalStatus ===
                                ApprovalStatusEnum.WaitingApproval
                              "
                            >
                              {{ "WaitingApproval" | translate }}
                            </p>
                            <p
                              style="font-size: 9px"
                              *ngIf="
                                ticket.approvalStatus ===
                                ApprovalStatusEnum.DeclinedApproval
                              "
                            >
                              {{ "Rejected" | translate }}
                            </p>
                          </div>
                          <img
                            src="{{
                              'https://api.qrserver.com/v1/create-qr-code/?data=' +
                                ticket.id +
                                '&margin=30&height=100'
                            }}"
                            alt=""
                            style="opacity: 0.4"
                            class="image"
                          />
                        </div>

                        <img
                          *ngIf="
                            ticket.approvalStatus ===
                            ApprovalStatusEnum.Approved
                          "
                          src="{{
                            'https://api.qrserver.com/v1/create-qr-code/?data=' +
                              ticket.id +
                              '&margin=30&height=100'
                          }}"
                          alt=""
                        />
                      </div>
                    </div>

                    <div class="text-center myTicket-number">
                      <h3 class="myTicket-user-name">
                        {{ "TicketNumber" | translate }}
                      </h3>
                      <p class="myTicket-user-phone text-center">
                        {{ ticket.number }}
                      </p>
                    </div>

                    <div class="myTicket-user">
                      <h3 class="myTicket-user-name">
                        {{
                          invoice?.metadata?.name.first +
                            " " +
                            invoice?.metadata?.name.last
                        }}
                      </h3>
                      <p class="myTicket-user-phone">
                        {{ invoice?.metadata.mobile }}
                      </p>
                      <p class="myTicket-user-email">
                        {{ invoice?.metadata.email }}
                      </p>
                    </div>
                  </div>

                  <div class="myTicket-partSeparator">
                    <div class="myTicket-partSeparator-line"></div>
                  </div>
                  <div class="myTicket-part2">
                    <h3 class="myTicket-name">
                      {{ helpers.getElementTranslatedName(ticket.ticket) }}
                    </h3>
                    <p class="myTicket-price">
                      <span
                        [innerHTML]="
                          ticket.ticket.price
                            | customCurrency : 'SAR' : 'symbol' : '#a1a1a1' : 28
                        "
                      ></span>
                    </p>
                    <!-- <button
                        type="button"
                        (click)="downloadTicket(ticket.ticket.id)"
                        class="btn myTicket-downloadBtn"
                      >
                        <i class="fas fa-cloud-download-alt"></i>
                        {{ "Download Ticket" | translate }}
                      </button> -->
                  </div>
                </div>
              </ng-container>
            </ng-template>
          </ngb-panel>
          <ngb-panel *ngIf="!invoice">
            <ng-template ngbPanelHeader let-opened="opened">
              <button
                class="custom-header"
                ngbPanelToggle
                [class.collapsed]="!opened"
              >
                <figure class="event-image ratio-wrapper">
                  <span class="skeleton-box ratio-wrapper__el"></span>
                </figure>
                <div class="details">
                  <h3><span class="skeleton-box"></span></h3>
                  <p><span class="skeleton-box"></span></p>
                </div>

                <span class="price"><span class="skeleton-box"></span></span>
              </button>
            </ng-template>
          </ngb-panel>
        </ng-container>
      </ngb-accordion>
    </div>
  </ng-container>

  <app-pagination
    *ngIf="invoices.meta"
    [meta]="invoices.meta"
    (goPage)="goToPage($event)"
    (goNext)="onNext()"
    (goPrev)="onPrev()"
  >
  </app-pagination>
</section>

<ng-template #noData>
  <app-nodata
    title="{{ 'No Tickets Yet' | translate }}"
    [img]="'assets/images/tickets/no-ticket.png'"
    link=""
  ></app-nodata>
</ng-template>

<ng-template #loading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-3x"></i>
  </div>
</ng-template>
